import React from 'react';
import { mockClients } from '../data/mockData';
import '../styles/ClientsSection.css';

const ClientsSection = () => {
  return (
    <section id="clients" className="clients-section">
      <div className="clients-container">
        <h2 className="section-title">OUR CLIENTS</h2>
        <p className="clients-subtitle">
          Here is a compilation of some renowned global clients that Digitronicks collaborates with.
        </p>
        
        <div className="clients-grid">
          {mockClients.map((client, index) => (
            <div key={index} className="client-logo-wrapper">
              <img 
                src={client.logo} 
                alt={client.name} 
                className="client-logo"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;